module.exports = __webpack_public_path__ + "media/images/plans/schedule_6-acf95ac1718845f1cc2b89fc843abf70.jpg";